<template>
  <EmbeddedLayout
    v-if="isThemeLoaded && theme == 'Operator-Template'"
    :style="merchantStyle"
  />
  <StandAloneLayout
    v-else-if="isThemeLoaded && theme != 'Operator-Template'"
    :style="merchantStyle"
  />

  <v-app v-else>
    <v-container>
      <MainLoader />
    </v-container>
  </v-app>
</template>
<style>
    @font-face {
        font-family: 'CorsaGrotesk';
        src: url('assets/Fonts/Corsa Grotesk/Corsa Grotesk Bold.otf') format('opentype');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'NotoSansArabic';
        src: url('assets/Fonts/NotoSansArabic/NotoSansArabic-Regular.ttf') format('opentype');
        font-weight: normal;
        font-style: normal;
    }
</style>
<script>
import axios from 'axios';
import { mapMutations, mapState } from 'vuex';
import languageKeys from 'constants/languageKeys';
import templateHelper from 'helper/templateHelper';
import StandAloneLayout from './layouts/Standalone';
import EmbeddedLayout from './layouts/Embedded';

import MainLoader from './components/Shared/components/MainLoader.vue';

export default {
  name: 'App',
  components: {
    MainLoader,
    StandAloneLayout,
    EmbeddedLayout,
  },
  data() {
    return {
      isThemeLoaded: false,
      theme: 'Template-A',
      bannerColor: '#FFFFFF',
      bannerImage: require('./assets/BackgroundBannerImage.png'),
      fontColor: '#3e484d',
      btnColor: '#8069FF',
      btnTextColor: '#FFFFFF',
      logo: require('./assets/LogoTransparent.png'),
      backgroundColor: '#8069FF',
      backgroundImage: require('./assets/BackgroundBannerImage.png'),
      isButtonRounded: true,
      languageCode: '',
      isRtl: false,
    };
  },
  methods: {
    ...mapMutations(['setTemplateConfig', 'setMerchantConfig']),
    async getCheckoutMerchantTemplate() {
      let response = await this.$http.get('/Template/CheckoutMerchantTemplate');
      let merchantTemplate = null;
      if (response.data) {
        this.languageCode = languageKeys[response.data.language]; // {1: 'en', 2: 'ar', 3: 'fr'}
        this.isRtl = this.languageCode === 'ar';
        this.$root.$i18n.locale = this.languageCode;
        this.$vuetify.lang.current = this.languageCode;
        this.$vuetify.rtl = this.isRtl;
        merchantTemplate = templateHelper.geMerchantTemplateData(
          response.data,
          this.languageCode
        );
        this.theme = merchantTemplate.templateName ?? this.theme;
        //this.theme = 'Operator-Template';
        this.bannerColor =
          merchantTemplate.placeholders?.bannerColor ?? this.bannerColor;
        this.bannerImage =
          merchantTemplate.placeholders?.bannerImage ?? this.bannerImage;
        this.logo = merchantTemplate.placeholders?.logo ?? this.logo;
        this.backgroundColor =
          merchantTemplate.placeholders?.backgroundColor ??
          this.backgroundColor;
        this.backgroundImage =
          merchantTemplate.placeholders?.backgroundImage ??
          this.backgroundImage;
        this.isButtonRounded =
          merchantTemplate.styles?.isButtonRounded ?? this.isButtonRounded;
        this.fontColor = merchantTemplate.styles?.fontColor ?? this.fontColor;
        this.btnColor =
          merchantTemplate.placeholders?.btnColor ?? this.btnColor;
        this.btnTextColor =
          merchantTemplate.placeholders?.btnTextColor ?? this.btnTextColor;
        this.setMerchantConfig({
          configs: merchantTemplate.configs,
          fields: merchantTemplate.fields,
          merchantId: merchantTemplate.merchantId,
          merchantName: merchantTemplate.merchantName,
          successMsgs: {
            successTitle: merchantTemplate.placeholders?.successTitle ?? '',
            successMessage: merchantTemplate.placeholders?.successMessage ?? '',
            successBtnText: merchantTemplate.placeholders?.successBtnText ?? '',
          },
          texts: merchantTemplate.texts,
        });
      }

      this.setTemplateConfig({
        theme: this.theme,
        bannerImage: this.bannerImage,
        bannerColor: this.bannerColor,
        fontColor: this.fontColor,
        btnColor: this.btnColor,
        btnTextColor: this.btnTextColor,
        logo: this.logo,
        backgroundColor: this.backgroundColor,
        backgroundImage: this.backgroundImage,
        isButtonRounded: this.isButtonRounded,
        language: this.languageCode,
        isRtl: this.isRtl,
      });
    },
  },
  computed: {
    ...mapState(['merchantConfig']),
    merchantStyle() {
      return {
        '--banner-color': this.bannerColor,
        '--banner-image': `url("${this.bannerImage}")`,
        '--background-color': this.backgroundColor,
        '--background-image': `url("${this.backgroundImage}")`,
        '--font-color': this.fontColor,
        '--btn-color': this.btnColor,
        '--btn-text-color': this.btnTextColor,
      };
    },
  },
  async created() {
    this.$router.afterEach(async (to) => {
      if(to.params.sessionId){
        axios.defaults.headers.common['session'] = to.params.sessionId;
        await this.getCheckoutMerchantTemplate();
        this.isThemeLoaded = true;
      }
    });
    
  },
};
</script>
